import { useId } from 'react';
import ReactTooltip from 'react-tooltip';

import LucideIcon from '../lucide-icon';

const Info = ({
  id,
  placement,
  text,
  className,
  style,
  renderContent,
  tooltipMaxWidth,
  tooltipTextAlign,
  size = 16,
}) => {
  const tooltipId = 'info-tooltip-' + useId().replace(/:/g, '');
  const validPositions = ['top', 'bottom', 'left', 'right'];
  const position = validPositions.includes(placement) ? placement : 'top';

  return (
    <span style={style} className={className}>
      <LucideIcon
        color="#ccc"
        colorHover="#ccc"
        icon="Info"
        size={size}
        id={id}
        data-tip
        data-for={tooltipId}
      />
      <ReactTooltip id={tooltipId} place={position} aria-haspopup="true">
        <div
          style={{
            maxWidth: tooltipMaxWidth != null ? tooltipMaxWidth : 200,
            textAlign: tooltipTextAlign != null ? tooltipTextAlign : 'center',
          }}
        >
          {renderContent ? renderContent() : text}
        </div>
      </ReactTooltip>
    </span>
  );
};

export default Info;
